import { render, staticRenderFns } from "./MsgRightItem.vue?vue&type=template&id=0db89976&scoped=true&"
import script from "./MsgRightItem.vue?vue&type=script&lang=ts&"
export * from "./MsgRightItem.vue?vue&type=script&lang=ts&"
import style0 from "./MsgRightItem.vue?vue&type=style&index=0&id=0db89976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db89976",
  null
  
)

export default component.exports